define(["require", "exports", "tslib", "./ServiceTransport"], function (require, exports, tslib_1, ServiceTransport_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ServiceTransportWithExportImport = void 0;
    var ServiceTransportWithExportImport = (function (_super) {
        (0, tslib_1.__extends)(ServiceTransportWithExportImport, _super);
        function ServiceTransportWithExportImport(channelFlag) {
            if (channelFlag === void 0) { channelFlag = ''; }
            return _super.call(this, channelFlag) || this;
        }
        ServiceTransportWithExportImport.prototype.get = function (url, config) {
            if (config === void 0) { config = {}; }
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var resultData;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.executeGet(url, config)];
                        case 1:
                            resultData = _a.sent();
                            if (resultData && resultData.data && config.responseType !== 'blob') {
                                return [2, resultData.data];
                            }
                            return [2, resultData];
                    }
                });
            });
        };
        ServiceTransportWithExportImport.prototype.post = function (url, data, config) {
            if (config === void 0) { config = {}; }
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var resultData;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.executePost(url, data, config)];
                        case 1:
                            resultData = _a.sent();
                            if (resultData && resultData.data && config.responseType !== 'blob') {
                                return [2, resultData.data];
                            }
                            return [2, resultData];
                    }
                });
            });
        };
        ServiceTransportWithExportImport.prototype.executeGet = function (url, config) {
            if (config === void 0) { config = {}; }
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var targetConfig_1;
                var _this = this;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(config && config.headers)) return [3, 1];
                            targetConfig_1 = {
                                method: 'get',
                                url: this.updateConfig(url),
                                headers: (0, tslib_1.__assign)({}, config.headers),
                                params: this.getCustomParams(url, config)
                            };
                            targetConfig_1 = this.addRequestConfig(config, targetConfig_1);
                            if (config.showLogs) {
                                console.log('生成的配置..', targetConfig_1);
                            }
                            return [2, new Promise(function (resolve, reject) {
                                    _this.apiService(targetConfig_1).then(function (response) {
                                        resolve(response);
                                    }).catch(function (e) {
                                        resolve(e);
                                    });
                                })];
                        case 1: return [4, this.apiService.get(this.updateConfig(url), this.transportConfig(url, config))];
                        case 2: return [2, _a.sent()];
                    }
                });
            });
        };
        ServiceTransportWithExportImport.prototype.executePost = function (url, data, config) {
            if (config === void 0) { config = {}; }
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var executeParams, targetConfig_2;
                var _this = this;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            executeParams = data;
                            if (!(config && config.headers)) return [3, 1];
                            targetConfig_2 = {
                                method: 'post',
                                url: this.updateConfig(url),
                                data: executeParams,
                                headers: (0, tslib_1.__assign)({}, config.headers),
                                params: this.getCustomParams(url, config)
                            };
                            targetConfig_2 = this.addRequestConfig(config, targetConfig_2);
                            if (config.showLogs) {
                                console.log('生成的配置..', targetConfig_2);
                            }
                            return [2, new Promise(function (resolve, reject) {
                                    _this.apiService(targetConfig_2).then(function (response) {
                                        resolve(response);
                                    }).catch(function (e) {
                                        resolve(e);
                                    });
                                })];
                        case 1: return [4, this.apiService.post(this.updateConfig(url), executeParams, this.transportConfig(url, config))];
                        case 2: return [2, _a.sent()];
                    }
                });
            });
        };
        ServiceTransportWithExportImport.prototype.executeDownload = function (res, type) {
            if (type === void 0) { type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'; }
            var fileName = '';
            if (res && res.headers && res.headers['content-disposition']) {
                fileName = decodeURI(res.headers['content-disposition'].split('=')[1]);
            }
            else {
                fileName = "".concat(Date.now(), "-test.xlsx");
            }
            var blob = new Blob([res.data], {
                type: type
            });
            var isEdge = navigator.userAgent.indexOf('Edge');
            if (isEdge >= 1) {
                var navigator_1 = window.navigator;
                navigator_1.msSaveOrOpenBlob(blob, fileName);
            }
            else {
                var objectUrl = URL.createObjectURL(blob);
                var a_1 = document.createElement('a');
                a_1.href = objectUrl;
                a_1.setAttribute('download', fileName);
                document.body.appendChild(a_1);
                a_1.click();
                var t_1 = setTimeout(function () {
                    document.body.removeChild(a_1);
                    clearTimeout(t_1);
                }, 1000);
            }
        };
        ServiceTransportWithExportImport.prototype.addRequestConfig = function (sourceConfig, targetConfig) {
            if (sourceConfig && targetConfig) {
                for (var key in sourceConfig) {
                    if (sourceConfig[key] && !targetConfig[key]) {
                        targetConfig[key] = sourceConfig[key];
                    }
                }
                return targetConfig;
            }
            else {
                throw new Error('sourceConfig, targetConfigy null.');
            }
        };
        return ServiceTransportWithExportImport;
    }(ServiceTransport_1.ServiceTransport));
    exports.ServiceTransportWithExportImport = ServiceTransportWithExportImport;
});
//# sourceMappingURL=ServiceTransportWithExportImport.js.map